import React from 'react'
import { Navigate } from 'react-router-dom'

const MoPhong: React.FC = () => {
  // Redirect to tổng hợp page - hiển thị tất cả video mô phỏng
  return <Navigate to="/tong-hop?class=11" replace />
}

export default MoPhong
